import React, { useEffect, useState } from "react";
//import { BASE_URL, AWS_URL } from "config/constants";
import api from "api/api";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Input from "@mui/material/Input";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

function Users() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const columns = [
    { Header: "SL.No", accessor: "sn", align: "left", sortable: true },
    { Header: "Name", accessor: "name", align: "left", sortable: true },
    { Header: "email", accessor: "email", align: "left", sortable: true },
    { Header: "Status", accessor: "status", align: "center", sortable: true },
    { Header: "Date", accessor: "date", align: "center", sortable: true },
  ];

  useEffect(() => {
    api
      .get("admin/users")
      .then((res) => {
        console.log("API Response:", res);
        const users = res.data?.user_list || res.data?.users || [];
        const formattedRows = users.map((user, index) => ({
          sn: index + 1,
          name: user.name || "N/A",
          email: user.email || "N/A",
          status: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={user.isActive === true ? "Active" : "Inactive"}
                color={user.isActive === true ? "success" : "error"}
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          date: user.created_at,
        }));

        setRows(formattedRows);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  }, []);

  const filteredRows = rows.filter(
    (row) =>
      row.name?.toLowerCase().includes(search.toLowerCase()) ||
      row.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    Users List
                  </MDTypography>
                  {/* Global search */}
                  <Input
                    type="text"
                    placeholder="Search users..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      backgroundColor: "#fff",
                      color: "#000",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      float: "right",
                    }}
                  />
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {loading ? (
                  <MDTypography px={2}>Loading...</MDTypography>
                ) : (
                  <DataTable
                    table={{ columns, rows: filteredRows }}
                    isSorted={true}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Users;
